import {getAsYouType, parsePhoneNumber as libParsePhoneNumber} from "awesome-phonenumber";
import {AreaCode, DEFAULT_AREA_CODE, getDialCode} from "./dialCodes";
import {PhoneNumber} from "./PhoneNumber";

/* We do not want a leading zero on a phone number */
function formatNationalNumber(nationalNumber?: string): string | undefined {
    if (!nationalNumber) {
        return;
    }
    if (nationalNumber.charAt(0) === "0") {
        return nationalNumber.substring(1, nationalNumber.length);
    }
    return nationalNumber;
}

/* We use this for parsing as a user types as we will know the region */
export function parsePhoneNumber(
    dialCode: string,
    phoneNumber: string,
    regionCode: string,
): PhoneNumber {
    const fullNumber = dialCode + phoneNumber;
    const result = libParsePhoneNumber(fullNumber, {regionCode});

    return new PhoneNumber(
        dialCode,
        regionCode,
        result?.number?.significant ?? phoneNumber,
        result.valid,
        formatNationalNumber(result?.number?.national),
    );
}

/* This is the initial parse of a phone number as we save a full phone number in our backend */
export function parseFullPhoneNumber(fullPhoneNumber: string): PhoneNumber {
    const result = libParsePhoneNumber(fullPhoneNumber);
    const areaCode: AreaCode = result?.regionCode
        ? getDialCode(result.regionCode)
        : DEFAULT_AREA_CODE;
    const regionCode = areaCode[0];
    const dialCode = areaCode[3];

    return new PhoneNumber(
        dialCode,
        regionCode,
        result?.number?.significant ?? result?.number?.input ?? "",
        result.valid,
        formatNationalNumber(result?.number?.national),
    );
}

export function makeCreateAsYouType(regionCode: string): (phoneNumber: string) => PhoneNumber {
    const asYouType = getAsYouType(regionCode);
    const areaCode = getDialCode(regionCode);
    const dialCode = areaCode[3];

    return (phoneNumber: string): PhoneNumber => {
        asYouType.reset(phoneNumber);
        const result = asYouType.getPhoneNumber();

        return new PhoneNumber(
            dialCode,
            regionCode,
            result?.number?.significant ?? asYouType.number(),
            result.valid,
            formatNationalNumber(result?.number?.national),
        );
    };
}
